// extracted by mini-css-extract-plugin
module.exports = {"group_8":"countryResponse_group_8__3o6VQ","group_9":"countryResponse_group_9__2xFd5"};